const GET_EDUCATIONS = 'GET_EDUCATIONS';

export default GET_EDUCATIONS;
